import { TCoreImageOptions } from '../types/options';

const px = (value: unknown): string | undefined => (typeof value === 'number' ? `${value}px` : undefined);

export const buildImageCssVars = (palette: TCoreImageOptions): Record<string, string> => {
    const margin = palette.margin ?? {};

    const vars: Record<string, string | undefined> = {
        '--cw-img-width': typeof palette.width === 'number' ? px(palette.width) : palette.width,
        '--cw-img-height': typeof palette.height === 'number' ? px(palette.height) : palette.height,
        '--cw-img-radius': px(palette.borderRadius),
        '--cw-img-margin-top': px(margin.top),
        '--cw-img-margin-right': px(margin.right),
        '--cw-img-margin-bottom': px(margin.bottom),
        '--cw-img-margin-left': px(margin.left),
        '--cw-img-overflow': palette.overflow,
    };

    return Object.fromEntries(Object.entries(vars).filter((entry): entry is [string, string] => entry[1] !== undefined));
};
